/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.apiLimits', [])
    .factory('apiLimitsService', ApiLimitsService)
    .name;

/*@ngInject*/
function ApiLimitsService($http, $q, types) {

    var service = {
        getApiLimits: getApiLimits,
        saveApiLimits: saveApiLimits,
        createDefaultApiLimits: createDefaultApiLimits
    }

    return service;

    function getApiLimits (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/apiLimits/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveApiLimits (apiLimits) {
        var deferred = $q.defer();
        var url = '/api/apiLimits';
        $http.post(url, apiLimits).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function createDefaultApiLimits() {
        return {
            enabled: false,
            timeUnit: types.apiLimitTimeUnit.DAYS.value,
            timeValue: 1,
            limit: 2147483647
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/api/api-limits.service.js